import {Component, Injectable, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {MenuService} from '../../services/menu.service';
import {TranslocoPipe, TranslocoService} from '@ngneat/transloco';
import {first} from 'rxjs/operators';
import {Router, RoutesRecognized} from "@angular/router";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [TranslocoPipe],
  encapsulation: ViewEncapsulation.None
})
@Injectable({
  providedIn: 'root'
})
export class MenuComponent implements OnInit {

  @Input() showMenu: boolean;

  public items: MenuItem[];

  private numberAlarms: number;
  private savedName: string;


  constructor(private menuService: MenuService,
              private i18n: TranslocoService,
              public router: Router) {
    this.menuService.getZoneEmitterName().subscribe(val => {
      this.savedName = val;
      this.loadItems();
    });
    this.menuService.getZoneEmitterNumberAlarms().subscribe(val => {
      this.numberAlarms = val;
      if (this.numberAlarms) {
        this.loadItems();
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        let uuid = val.url.split('/');
        if (uuid.length != 1) {
          this.loadItems();
        }
      }
    });
    this.i18n.langChanges$.subscribe(() => this.loadItems());
  }

  private loadItems(): void {
    const promises: any[] = [];
    const items: any[] = [];
    this.menuService.getItems().forEach(item => {
      promises.push(this.i18n.selectTranslate(item.label).pipe(first()).toPromise());
      items.push({label: item.label, icon: item.icon, routerLink: item.routerLink, id: item.id});
    });
    Promise.all(promises).then(values => {
      for (let i = 0; i < values.length; i++) {
        if (i < items.length)
          items[i].label = values[i];
      }
      this.items = items;
    });
  }

}
